import React from 'react';
import './index.css';

import main from 'assets/images/contacto-main.png';

function Article() {
  return (
    <div className='columns contacto2'>
      <div className='col'>
        <h4>Canales de contacto</h4>
        <h5>Si querés ser asistido/a por un/a representante del área de Relaciones con el Sector Público:</h5>
        <ul className="contactos">
          <li><span>Sra. Mara Martin</span></li>
          <li><span>Srta. Antonela Brom</span></li>
          <li><span>Srta. Sara Iturralde</span></li>
          <li><span>Sr. Fernando Iannonne</span></li>
          <li><span>Sr. Diego Toledo</span></li>
        </ul>
      </div>
      <div className='col'>
        <ul className='contacto2-list'>
          <li className='tel'>
            <i></i>
            <span>Teléfono<br />
              <a href="tel:+01143470255">(011) 4347-0255</a>
            </span>
          </li>
          <li className='mai'>
            <i></i>
            <span>E-mail<br />
              <a href="mailto:relacionesconelsectorpublico@bpba.com.ar">RelacionesconelSectorPublico-Negocios@bpba.com.ar</a>
            </span>
          </li>
        </ul>
      </div>
      <div className='col img'>
        <img src={main} alt="Contacto" />
      </div>
    </div>
  )
}

export default Article;
